import * as React from "react";

import { useFormContext, useWatch } from "react-hook-form";

import { hasValue, isNullable } from "@cak-legacy/core-utils";
import { DynamicFieldSchema } from "@cak-legacy/generation-core";

import { useFieldRenderContext } from "../Context/FieldRenderContextProvider";

export interface DynamicFieldProps {
  name: string;
  field: DynamicFieldSchema;
}

export const DynamicField = React.memo((props: DynamicFieldProps) => {
  const formContext = useFormContext();
  const renderContext = useFieldRenderContext();

  if (!renderContext) {
    return null;
  }

  const watchOptions = hasValue(props.field.watch)
    ? { name: props.field.watch }
    : { disabled: isNullable(props.field.watch) };

  useWatch(watchOptions);

  const values = formContext.getValues() ?? {};
  const schema = props.field.getSchema?.(values);

  return (
    <renderContext.dynamic field={props.field}>
      {props.field.createComponent(values, props.name, schema)}
    </renderContext.dynamic>
  );
});
